import React from "react";
import { ReferenceField, FunctionField } from "react-admin";


export const ThirdPartyField = ({
	link = false,
	sortable = true,
	...props
}) => (
		<ReferenceField
			link={link}
			sortable={sortable}
			{...props}
			reference="third-party-apps"
		>
			<FunctionField render={(record) => record.client_name} />
		</ReferenceField>
);
